<script setup>
import { onUnmounted, onMounted } from "vue";
import { ref } from "vue";
import eventBus from "../Helpers/eventBus.js";
import { DateTime } from "luxon";

const props = defineProps({
    showUTC: {
        type: Boolean,
        default: () => {
            return true;
        },
    },
    // https://moment.github.io/luxon/#/formatting
    luxonPreset: {
        type: String,
        default: () => {
            return "DATETIME_SHORT";
        },
    },
});

const humanTime = ref("syncing...");

const updateTimeForTheLocalEventTimeComponent = function ({ device_ts_ms_offset, timezone }) {
    device_ts_ms_offset = device_ts_ms_offset || 0;

    const localRallyDateTime = DateTime.now().minus(device_ts_ms_offset).setZone(timezone);

    const LocalEventTimeForHuman = localRallyDateTime.toLocaleString(DateTime[props.luxonPreset]);

    if (props.showUTC) {
        humanTime.value = `${LocalEventTimeForHuman} UTC${localRallyDateTime.toFormat("Z")}`;
    } else {
        humanTime.value = LocalEventTimeForHuman;
    }
};

onMounted(() => {
    // console.log("onMounted LocalEventTime");
    eventBus.$on("updateTimeForTheLocalEventTimeComponent", (args) => {
        // console.log("on updateTimeForTheLocalEventTimeComponent");
        updateTimeForTheLocalEventTimeComponent(args);
    });
});

onUnmounted(() => {
    // console.log("onUnmounted LocalEventTime");
    eventBus.$off("updateTimeForTheLocalEventTimeComponent");
});
</script>

<template>
    <span class="tabular-nums">
        {{ humanTime }}
    </span>
</template>
